interface IndexIconTooltipProps {
    edgeProximity: {
        top: boolean;
        right: boolean;
        bottom: boolean;
        left: boolean;
    }
}

// Tooltip displayed for index banner map icon
const IndexIconTooltip = ( { edgeProximity }: IndexIconTooltipProps) => (
    <span className={`absolute hidden group-hover:block bg-black/70 text-white text-xs rounded py-1 px-2 w-32 
        ${edgeProximity.right ? 'right-full mr-2' : 'left-5'} 
        ${edgeProximity.top ? 'top-4' : ''} 
        ${edgeProximity.bottom ? 'bottom-4' : ''}
        ${edgeProximity.left ? 'left-full ml-2' : ''}
        whitespace-nowrap text-wrap`}>
    Click this icon to display the current index on the map.
    </span>
);

export default IndexIconTooltip;